import React, { useEffect, useContext, useState } from 'react'
import { colors } from '../../const'
import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ISwapVolumePCTByChain } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getSwapVolumePCTByChainConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_volume_pct_by_chain', timeframe)) as ISwapVolumePCTByChain[]
	const btcData = chartData.filter((row) => row.BLOCKCHAIN === 'BTC')
	const ethData = chartData.filter((row) => row.BLOCKCHAIN === 'ETH')
	const bchData = chartData.filter((row) => row.BLOCKCHAIN === 'BCH')
	const avaxData = chartData.filter((row) => row.BLOCKCHAIN === 'AVAX')
	const baseData = chartData.filter((row) => row.BLOCKCHAIN === 'BASE')
	const dogeData = chartData.filter((row) => row.BLOCKCHAIN === 'DOGE')
	const ltcData = chartData.filter((row) => row.BLOCKCHAIN === 'LTC')
	const atomData = chartData.filter((row) => row.BLOCKCHAIN === 'GAIA')
	const tcData = chartData.filter((row) => row.BLOCKCHAIN === 'THOR')
	const bscData = chartData.filter((row) => row.BLOCKCHAIN === 'BSC')
	const xrpData = chartData.filter((row) => row.BLOCKCHAIN === 'XRP')
	const tronData = chartData.filter((row) => row.BLOCKCHAIN === 'TRON')
	const zecData = chartData.filter((row) => row.BLOCKCHAIN === 'ZEC')

	let series1,
		series2,
		series3,
		series4,
		series5,
		series6,
		series7,
		series8,
		series9,
		series10,
		series11,
		series12,
		series13: {
			x: number
			y: number
		}[] = []

	if (timeframe === '1w' || timeframe === '1d') {
		series1 = btcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series2 = ethData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series3 = bchData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series4 = avaxData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series5 = tcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series6 = baseData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series7 = dogeData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series8 = atomData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series9 = ltcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series10 = bscData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series11 = xrpData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series12 = tronData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series13 = zecData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
	} else {
		// if (timeframe === '1m')
		series1 = btcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series2 = ethData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series3 = bchData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series4 = avaxData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series5 = tcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series6 = baseData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series7 = dogeData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series8 = atomData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series9 = ltcData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series10 = bscData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series11 = xrpData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series12 = tronData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series13 = zecData.map((element: ISwapVolumePCTByChain) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
	}

	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'BTC',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[0]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'ETH',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[1]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'BSC',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[2]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'THOR',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[3]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BCH',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[4]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'LTC',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[5]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'AVAX',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[6]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'DOGE',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[7]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'ATOM',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[8]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'BASE',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[9]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series11,
			strokeWidth: 2,
			name: 'XRP',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[10]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'TRON',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[11]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		},
		{
			data: series13,
			strokeWidth: 2,
			name: 'ZEC',
			type: 'bars',
			seriesGroup: '[% of total]',
			color: `${colors[13]}`,
			unitSymbol: '%',
			barGroup: 'usd'
		}
	]
	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const SwapVolumePCTByChain = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getSwapVolumePCTByChainConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Percentage of the Total Swap Volume by Chain"
			chartDesc="Percentage share of total THORChain swap volume contributed by each connected chain. Makes relative dominance and shifts in chain usage immediately visible."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="4a58eec2-db67-48a0-8116-424979a54ee6"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasDays={false}
			sortByValueDesc={true}
		/>
	)
}

export default SwapVolumePCTByChain
